import {Switch} from '@wandb/weave/components';
import React from 'react';

import {trackPanelSearchAutoExpandToggled} from '../../../services/analytics';
import {usePart} from '../../../state/views/hooks';
import {useWorkspaceRefsContext} from '../../Workspace/WorkspaceRefsContext';

export const SearchAutoExpandToggle = () => {
  const {panelBankActions, panelBankConfigRef} = useWorkspaceRefsContext();
  const panelBankConfigPart = usePart(panelBankConfigRef);
  const {autoExpandSearchResults} = panelBankConfigPart.settings;

  return (
    <div className="ml-auto flex items-center gap-8">
      <label
        className="cursor-pointer whitespace-nowrap"
        htmlFor="auto-expand-toggle">
        Auto-expand search results
      </label>
      <Switch.Root
        id="auto-expand-toggle"
        size="small"
        checked={autoExpandSearchResults}
        onCheckedChange={isOn => {
          trackPanelSearchAutoExpandToggled({value: isOn});
          panelBankActions.updatePanelBankSettings({
            autoExpandSearchResults: isOn,
            searchSectionsOpen: undefined,
          });
        }}>
        <Switch.Thumb size="small" checked={autoExpandSearchResults ?? false} />
      </Switch.Root>
    </div>
  );
};
